(function () {
  'use strict';

  console.log('[Delivery Badge] Script loaded');

  const CONFIG = {
    timeZone: 'America/New_York',

    cutoffHour: 12,
    cutoffMinute: 0,

    // TEST MODE
    testMode: false,
    testDay: 'Mon', // Mon, Tue, Wed, Thu, Fri, Sat, Sun
    testHour: 11,
    testMinute: 30,
    testSecond: 0,

    /*
      Скрипт активируется только тогда,
      когда исходный title приложения равен DELIVERY.
    */
    activationTitle: 'DELIVERY',

    widgetSelector:
      '.essential-estimated-delivery-widget',

    titleSelector:
      '.essential-estimated-delivery-description-title',

    subtitleSelector:
      '.essential-estimated-delivery-description-sub-title',

    /*
      Элемент Wokiee, который выводится,
      когда выбранный вариант отсутствует.
    */
    soldOutSelector:
      '.tt-add-info .availability .sold_out',

    /*
      Блок наличия товара.
    */
    availabilitySelector:
      '.tt-add-info .availability',

    /*
      Стабильный контейнер информации о товаре.
      Observer следит за ним, поскольку блок наличия
      может полностью заменяться при смене варианта.
    */
    productInfoSelector:
      '.tt-product-single-info',

    hiddenClass:
      'ny-delivery-hidden-out-of-stock',

    styleId:
      'ny-delivery-stock-style',

    widgetWaitTimeout: 30000
  };

  let widgetObserver = null;
  let pageObserver = null;
  let stockObserver = null;
  let updateTimer = null;

  const dateTimeFormatter =
    new Intl.DateTimeFormat('en-US', {
      timeZone: CONFIG.timeZone,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

  /*
    Добавляет CSS для скрытия виджета.

    Используем класс, чтобы не перезаписывать
    исходный inline display приложения.
  */
  function injectStyles() {
    if (
      document.getElementById(CONFIG.styleId)
    ) {
      return;
    }

    const style =
      document.createElement('style');

    style.id = CONFIG.styleId;

    style.textContent =
      '.' + CONFIG.hiddenClass + ' {' +
        'display: none !important;' +
      '}';

    document.head.appendChild(style);
  }

  function getNewYorkTime() {
    if (CONFIG.testMode) {
      return {
        weekday: CONFIG.testDay,
        hour: CONFIG.testHour,
        minute: CONFIG.testMinute,
        second: CONFIG.testSecond
      };
    }

    const values = {};

    dateTimeFormatter
      .formatToParts(new Date())
      .forEach(function (part) {
        if (part.type !== 'literal') {
          values[part.type] = part.value;
        }
      });

    return {
      weekday: values.weekday,
      hour: Number(values.hour),
      minute: Number(values.minute),
      second: Number(values.second)
    };
  }

  function formatCountdown(totalSeconds) {
    const safeSeconds = Math.max(
      0,
      totalSeconds
    );

    const hours = Math.floor(
      safeSeconds / 3600
    );

    const minutes = Math.floor(
      (safeSeconds % 3600) / 60
    );

    return [
      String(hours).padStart(2, '0') + 'h',
      String(minutes).padStart(2, '0') + 'm'
    ].join(' ');
  }

  function buildMessage(now) {
    const isFriday =
      now.weekday === 'Fri';

    const isWeekend =
      now.weekday === 'Sat' ||
      now.weekday === 'Sun';

    if (isWeekend) {
      return {
        html:
          '<span class="ny-delivery-message">' +
            'Weekend orders ship Monday.' +
          '</span>'
      };
    }

    const currentSeconds =
      now.hour * 3600 +
      now.minute * 60 +
      now.second;

    const cutoffSeconds =
      CONFIG.cutoffHour * 3600 +
      CONFIG.cutoffMinute * 60;

    const isBeforeCutoff =
      currentSeconds < cutoffSeconds;

    if (isBeforeCutoff) {
      const remainingSeconds =
        cutoffSeconds - currentSeconds;

      return {
        html:
          '<span class="ny-delivery-message">' +
            'Order within ' +
            '<span class="ny-delivery-countdown">' +
              formatCountdown(remainingSeconds) +
            '</span> ' +
            'to ship today.' +
          '</span>'
      };
    }

    if (isFriday) {
      return {
        html:
          '<span class="ny-delivery-message">' +
            'Orders placed now ship Monday.' +
          '</span>'
      };
    }

    return {
      html:
        '<span class="ny-delivery-message">' +
          'Orders placed now ship tomorrow.' +
        '</span>'
    };
  }

  function getTitleElement(widget) {
    return widget.querySelector(
      CONFIG.titleSelector
    );
  }

  function getSubtitleElement(widget) {
    return widget.querySelector(
      CONFIG.subtitleSelector
    );
  }

  function normalizeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /*
    Проверяет, отображается ли элемент
    на странице в данный момент.
  */
  function isElementVisible(element) {
    if (!element) {
      return false;
    }

    const styles =
      window.getComputedStyle(element);

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      styles.opacity !== '0' &&
      !element.hidden &&
      !element.classList.contains('hide') &&
      element.getClientRects().length > 0
    );
  }

  /*
    Проверяет наличие видимого OUT OF STOCK.
  */
  function isProductOutOfStock() {
    const soldOutElements =
      document.querySelectorAll(
        CONFIG.soldOutSelector
      );

    return Array.from(
      soldOutElements
    ).some(function (element) {
      const text = normalizeText(
        element.textContent
      ).toUpperCase();

      return (
        isElementVisible(element) &&
        text.includes('OUT OF STOCK')
      );
    });
  }

  /*
    Скрывает или показывает виджет через класс.

    Исходные стили приложения при этом
    не изменяются.
  */
  function updateWidgetVisibility(widget) {
    if (!widget) {
      return false;
    }

    const shouldHide =
      isProductOutOfStock();

    widget.classList.toggle(
      CONFIG.hiddenClass,
      shouldHide
    );

    return shouldHide;
  }

  function startObservingWidget(widget) {
    if (!widgetObserver || !widget) {
      return;
    }

    widgetObserver.observe(widget, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function stopObservingWidget() {
    if (widgetObserver) {
      widgetObserver.disconnect();
    }
  }

  /*
    На время собственных изменений текста
    отключаем observer виджета.

    Это предотвращает бесконечный цикл
    после изменения innerHTML.
  */
  function performInternalUpdate(
    widget,
    callback
  ) {
    stopObservingWidget();

    try {
      callback();
    } finally {
      startObservingWidget(widget);
    }
  }

  /*
    Проверяет активационный title DELIVERY.

    После первой успешной активации сохраняет
    состояние в data-атрибуте, поскольку затем
    title заменяется нашим сообщением.
  */
  function activateWidgetIfAllowed(widget) {
    const title =
      getTitleElement(widget);

    if (!title) {
      return false;
    }

    const currentTitle =
      normalizeText(title.textContent);

    if (
      currentTitle ===
      CONFIG.activationTitle
    ) {
      widget.dataset.nyDeliveryEnabled =
        'true';

      return true;
    }

    return (
      widget.dataset.nyDeliveryEnabled ===
      'true'
    );
  }

  function updateWidget(widget) {
    if (
      !widget ||
      !widget.isConnected
    ) {
      return false;
    }

    const title =
      getTitleElement(widget);

    // const subtitle =
    //   getSubtitleElement(widget);

    if (!title) {
      return false;
    }

    /*
      Сначала проверяем DELIVERY.

      Если title другой, скрипт не скрывает виджет
      и не меняет его содержимое.
    */
    if (!activateWidgetIfAllowed(widget)) {
      return true;
    }

    /*
      Проверка OUT OF STOCK выполняется только
      для активированного DELIVERY-виджета.
    */
    if (updateWidgetVisibility(widget)) {
      return true;
    }

    const message =
      buildMessage(getNewYorkTime());

    // const subtitleText =
    //   'Dispatch schedule based on New York time.';

    const titleNeedsUpdate =
      title.innerHTML !== message.html;

    // const subtitleNeedsUpdate =
    //   subtitle &&
    //   normalizeText(
    //     subtitle.textContent
    //   ) !== subtitleText;

    if (
      !titleNeedsUpdate
    ) {
      return true;
    }

    performInternalUpdate(
      widget,
      function () {
        if (titleNeedsUpdate) {
          title.innerHTML =
            message.html;
        }

        // if (subtitleNeedsUpdate) {
        //   subtitle.textContent =
        //     subtitleText;
        // }
      }
    );

    return true;
  }

  function getNextUpdateDelay(now) {
    const isWeekday =
      now.weekday !== 'Sat' &&
      now.weekday !== 'Sun';

    const currentSeconds =
      now.hour * 3600 +
      now.minute * 60 +
      now.second;

    const cutoffSeconds =
      CONFIG.cutoffHour * 3600 +
      CONFIG.cutoffMinute * 60;

    const isCountdownActive =
      isWeekday &&
      currentSeconds < cutoffSeconds;

    /*
      Таймер показывает только часы и минуты,
      поэтому обновляется в начале
      следующей минуты.
    */
    if (isCountdownActive) {
      return Math.max(
        1000,
        (60 - now.second) * 1000
      );
    }

    return 30000;
  }

  function scheduleNextUpdate(widget) {
    window.clearTimeout(updateTimer);

    if (
      !widget ||
      !widget.isConnected
    ) {
      waitForWidget();
      return;
    }

    const now =
      getNewYorkTime();

    updateWidget(widget);

    updateTimer =
      window.setTimeout(
        function () {
          scheduleNextUpdate(widget);
        },
        getNextUpdateDelay(now)
      );
  }

  /*
    Следит за внешними изменениями
    самого Essential-виджета.
  */
  function observeWidget(widget) {
    stopObservingWidget();

    widgetObserver =
      new MutationObserver(
        function () {
          window.requestAnimationFrame(
            function () {
              if (
                widget &&
                widget.isConnected
              ) {
                updateWidget(widget);
              }
            }
          );
        }
      );

    startObservingWidget(widget);
  }

  /*
    Проверяет, относится ли mutation
    к блоку наличия товара.
  */
  function mutationAffectsAvailability(
    mutation
  ) {
    let target = mutation.target;

    if (
      target &&
      target.nodeType !== Node.ELEMENT_NODE
    ) {
      target = target.parentElement;
    }

    if (
      target &&
      (
        target.matches?.(
          CONFIG.availabilitySelector
        ) ||
        target.closest?.(
          CONFIG.availabilitySelector
        )
      )
    ) {
      return true;
    }

    const addedNodes =
      Array.from(mutation.addedNodes || []);

    const removedNodes =
      Array.from(mutation.removedNodes || []);

    return addedNodes
      .concat(removedNodes)
      .some(function (node) {
        if (
          node.nodeType !==
          Node.ELEMENT_NODE
        ) {
          return false;
        }

        return (
          node.matches?.(
            CONFIG.availabilitySelector
          ) ||
          node.querySelector?.(
            CONFIG.availabilitySelector
          )
        );
      });
  }

  /*
    Следит за переключением вариантов.

    Observer находится на стабильном контейнере,
    но обновляет виджет только тогда, когда
    изменение связано с блоком availability.
  */
  function observeStockChanges(widget) {
    if (stockObserver) {
      stockObserver.disconnect();
    }

    const observationTarget =
      document.querySelector(
        CONFIG.productInfoSelector
      ) || document.body;

    if (!observationTarget) {
      return;
    }

    stockObserver =
      new MutationObserver(
        function (mutations) {
          const availabilityChanged =
            mutations.some(
              mutationAffectsAvailability
            );

          if (!availabilityChanged) {
            return;
          }

          window.requestAnimationFrame(
            function () {
              if (
                widget &&
                widget.isConnected
              ) {
                updateWidget(widget);
              }
            }
          );
        }
      );

    stockObserver.observe(
      observationTarget,
      {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: [
          'class',
          'style',
          'hidden'
        ]
      }
    );
  }

  function start(widget) {
    /*
      Сначала проверяем исходный DELIVERY,
      пока приложение ещё не заменило title.
    */
    updateWidget(widget);

    observeWidget(widget);
    observeStockChanges(widget);
    scheduleNextUpdate(widget);
  }

  function waitForWidget() {
    const existingWidget =
      document.querySelector(
        CONFIG.widgetSelector
      );

    if (existingWidget) {
      start(existingWidget);
      return;
    }

    if (pageObserver) {
      pageObserver.disconnect();
    }

    pageObserver =
      new MutationObserver(
        function () {
          const widget =
            document.querySelector(
              CONFIG.widgetSelector
            );

          if (!widget) {
            return;
          }

          pageObserver.disconnect();
          pageObserver = null;

          start(widget);
        }
      );

    pageObserver.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );

    window.setTimeout(
      function () {
        if (pageObserver) {
          pageObserver.disconnect();
          pageObserver = null;
        }
      },
      CONFIG.widgetWaitTimeout
    );
  }

  function destroy() {
    window.clearTimeout(updateTimer);

    updateTimer = null;

    if (widgetObserver) {
      widgetObserver.disconnect();
      widgetObserver = null;
    }

    if (stockObserver) {
      stockObserver.disconnect();
      stockObserver = null;
    }

    if (pageObserver) {
      pageObserver.disconnect();
      pageObserver = null;
    }
  }

  function init() {
    injectStyles();
    waitForWidget();

    window.addEventListener(
      'pagehide',
      destroy,
      {
        once: true
      }
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true
      }
    );
  } else {
    init();
  }
})();